import React from 'react';

export const ChevronRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 17"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.17461 3.44802C6.38428 3.26831 6.69993 3.29259 6.87964 3.50225L10.8796 8.16892C11.0401 8.35616 11.0401 8.63246 10.8796 8.81971L6.87964 13.4864C6.69993 13.696 6.38428 13.7203 6.17461 13.5406C5.96495 13.3609 5.94067 13.0452 6.12038 12.8356L9.84147 8.49431L6.12038 4.15304C5.94067 3.94338 5.96495 3.62773 6.17461 3.44802Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
